export default "__VITE_ASSET__CsxlgIVA__";